import styled from 'styled-components';
import NewsItem from '../../../Components/NewsItem';
import useI18n from '../../../i18n';
import { getShortTextFromHTML } from '../../../utils/text';
import { ReactComponent as ArrowIcon } from 'Assets/Icons/navigate-right.svg?react';
import { Link } from 'react-router-dom';

const Wrapper = styled.div`
  padding: 24px 16px 32px;

  @media (min-width: calc(768px + 303px)) {
    max-width: 720px;
    margin: 0 auto;
    padding: 24px 0 32px;
  }

  @media (min-width: calc(992px + 303px)) {
    max-width: 960px;
  }

  @media (min-width: calc(1200px + 303px)) {
    max-width: 1140px;
  }
`;

const ViewMore = styled(Link)`
  color: rgb(117, 117, 120);
  font-weight: 600;
  cursor: pointer;

  svg {
    width: 12px;
    height: 12px;
    margin-left: 5px;
    fill: rgb(117, 117, 120);
  }

  @media (min-width: 768px) {
    &:hover {
      text-decoration: underline;
    }
  }
`;

const Heading = styled.h3`
  font-size: 16px;
  line-height: 24px;
  color: #757578;
  letter-spacing: 0.24px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

type Props = {
  /**
   * content
   */
  content: any; // needs to be changed in the backend
};

/**
 * NewsSection component
 */
const NewsSection = ({ content }: Props) => {
  if (!content) {
    return null;
  }

  const { i18n } = useI18n();
  const title = i18n(content.title);
  const text = i18n(content.text);
  const image = content.image.file.url;
  const shortText = getShortTextFromHTML(text, 100);
  const date = content.updatedAt;
  const { id } = content;

  return (
    <Wrapper>
      <Heading>
        {i18n('Landingpage.News')}
        <ViewMore to="/news">
          {i18n('Home.Categories.More')}
          <ArrowIcon />
        </ViewMore>
      </Heading>
      <NewsItem id={id} image={image} title={title} text={shortText} date={date} />
    </Wrapper>
  );
};

export default NewsSection;
